<template>
  <ValidationProvider name="은행" rules="required">
    <v-autocomplete
      v-model="selBank"
      ref="select"
      :items="banks"
      :error="error"
      outlined
      hide-details
      height="46"
      item-text="name"
      item-value="value"
      :readonly="readonly"
      :disabled="disabled"
      placeholder="은행 선택"
      @change="$emit('update:bankCode', selBank)"
    ></v-autocomplete>
  </ValidationProvider>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    bankCode: {
      Type: String,
      default: null,
    },
    error: {
      Type: Boolean,
      default: false,
    },
    readonly: {
      Type: Boolean,
      default: false,
    },
    disabled: {
      Type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      banksObj: {},
      selBank: null,
    }
  },
  computed: {
    banks() {
      const banks = []
      for (const k in this.banksObj) {
        banks.push({
          name: this.banksObj[k],
          value: k,
        })
      }
      return banks
    },
  },
  watch: {
    bankCode: {
      handler(v) {
        this.selBank = v
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('choice', ['getBanks']),
  },
  async created() {
    this.banksObj = await this.getBanks()
  },
}
</script>

<style lang="scss" scoped></style>
